"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var FilterDropdownMenuWrapper = function (props) { return (React.createElement("div", { className: props.className, onClick: function (e) { return e.stopPropagation(); } }, props.children)); };
exports.default = FilterDropdownMenuWrapper;
//# sourceMappingURL=FilterWrapper.js.map